/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_Q7Inputs */

const es_marketplace_seo_spain_faq_q7 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué licencia necesito para alquilar un barco sin patrón?`)
};

const gl_marketplace_seo_spain_faq_q7 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que licenza necesito para aluguer un barco sen patrón?`)
};

const en_marketplace_seo_spain_faq_q7 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What licence do I need to rent a boat without a skipper?`)
};

/**
* | output |
* | --- |
* | "What licence do I need to rent a boat without a skipper?" |
*
* @param {Marketplace_Seo_Spain_Faq_Q7Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_q7 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_Q7Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_Q7Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_q7(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_q7(inputs)
	return es_marketplace_seo_spain_faq_q7(inputs)
});